import { ReactElement } from "react";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";

import { toastError } from "../toasts";

export const generatePdfDocument = async (
  document: ReactElement,
  fileName: string
) => {
  try {
    const pdfFile = await pdf(document);
    const result = await pdfFile.toBlob();
    saveAs(result, fileName);
  } catch (error: any) {
    toastError("Error of saving to pdf. Reload page and try again");
  }
};
